import * as React from 'react';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { LangKey } from '../../../LangKey';
import Button from '../../../uicomponents/Button';
import { DataNodePropCategory, DataNodePropDynamicCategory, dataNodePropType } from '../../../models/DataNodeUtils';
import { DescriptorType } from '@simosol/iptim-data-model';

type Item = DataNodePropCategory | DataNodePropDynamicCategory;

type CategoryPropEditorProps = {
  item: Item;
  open: boolean;
  onClose: () => void;
};

const unsetValue = '__unset__';

const EditorCategory = (props: CategoryPropEditorProps) => {
  const { open, onClose, item } = props;

  const formValue = (item: Item) => item.value !== undefined && item.value !== null
    ? item.value.toString()
    : unsetValue;

  const [value, setValue] = React.useState<string>(
    () => formValue(item),
  );

  const cancel = () => {
    setValue(formValue(item));
    onClose();
  };

  const save = () => {
    if (value === unsetValue) {
      item.value = undefined;
    } else {
      if (dataNodePropType(item, DescriptorType.category)) {
        item.value = Number(value);
      } else if (dataNodePropType(item, DescriptorType.dynamicCategory)) {
        item.value = value;
      }
    }
    onClose();
  };

  const options: { value: string | number, label: string }[] =
    React.useMemo(() => item.getOptions(), [item]);

  const onOptionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.currentTarget.value);
  };

  return (
    <Dialog
      keepMounted
      fullWidth
      maxWidth="xs"
      open={open}
      onClose={cancel}
    >
      <DialogTitle>{item.displayName}</DialogTitle>
      <DialogContent dividers>
        <RadioGroup
          value={value}
          onChange={onOptionChange}
        >
          {options.map(option => (
            <FormControlLabel
              value={option.value.toString()}
              key={option.value}
              control={<Radio />}
              label={option.label}
            />
          ))}
        </RadioGroup>
      </DialogContent>
      <DialogActions>
        <Button onClick={cancel}>{LangKey.CommonCancel}</Button>
        <Button onClick={save}>{LangKey.CommonOk}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditorCategory;
